import { render } from "./IntroGrid.vue?vue&type=template&id=62522a23&ts=true"
import script from "./IntroGrid.vue?vue&type=script&lang=ts"
export * from "./IntroGrid.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__